import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import { Fragment } from 'react';
import translator from '@Components/Utilities/Translator';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';

const DealerWebSiteDesignView = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const buildSiteLinks = (sites) => {
        return (
            <div className='mock-container'>
                {sites.map(site =>
                    <Fragment key={site.Name}>
                        {site.Name && site.Name !== '' ?
                            <div className='column6'>
                                <a className='mock-link' href={site.Url} target='_blank' aria-label={site.Name + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                    <img className='mock-image' src={site.ImageLink} alt={site.AltText} />{site.Name}
                                </a>
                            </div>
                            :
                            <img className='mock-image' src={site.ImageLink} alt={site.AltText} />}
                    </Fragment>)}
            </div>
        );
    };

    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.PageTitle}</h1>
            </div>
            <div className='contact-us-container'>
                <div className='dealer-sites'>
                    <p>
                        {props.ProperDisplayDomainName}'s Web design department focuses on creating the best looking websites, designed exclusively for each dealer. <br/>
                        <strong>To find out more about how we can create your perfect {props.EquipmentType} dealer website, speak to your account manager at <a className='mock-link' href={'tel:' + props.TollFreeNumber}>{props.TollFreeNumber}</a> or <a className='mock-link' href={props.ContactUsUrl}>Click Here</a> to contact us.</strong>
                    </p>

                    {buildSiteLinks(props.MockSites.filter(x => x.Name && x.Name !== ''))}

                    <ul>
                        <li>Completely customisable</li>
                        <li>Dealer owns the domain name</li>
                        <li>{currentSite?.Site?.IsDotCom ? 'Corporate Email included – no more Gmail!' : 'Design and management services at no charge'}</li>
                        <li>One point of data entry for stock</li>
                        <li>Integrated website analytics</li>
                        <li>SEO friendly design</li>
                    </ul>

                    <p>You would deal directly with your own account manager and our web development team to build a website that is right for you, the dealer, and right for your customers. With a stock management system that has been refined over decades, you can be sure that the stock displayed on your website will be accurate and look great.</p>
                    <p>Best of all, the stock advertised on a dealer's custom hosted website is linked to the <a className='mock-link' href={props.CurrentDomainUrl}><span id='send-email-link' className='theme-text-color'>{props.FullDomainName}</span></a> website for maximum exposure.</p>

                    {buildSiteLinks(props.MockSites.filter(x => x.Name == null || x.Name == '' ))}

                    <h3>Benefits Of Hosting With {props.FormalDomainName}</h3>
                    <p>
                        When your business and the technology behind it are secure, up-to-date, and running smoothly, you're better able to service your customers. With our cutting-edge software solutions and the help we provide for you to use the systems, your focus can remain on your customers and your business - let us worry about the logistics.<br/><br/>

                        <strong>Security</strong><br/>
                        As the technology at {props.FormalDomainName} evolves, so do our security protocols and preventative measures which ensure your data remains protected. Advanced security protocols - from data encryption and the use of virtual private networks, to data redundancy and third-party verified interface solutions - ensure that digital security is an evolving and ongoing priority. Of course, our in-house IT support specialists are also available to assist dealers with security questions or concerns on an ongoing basis.<br/><br/>

                        <strong>Data Redundancy</strong><br/>
                        At {props.FormalDomainName} we continuously invest in our data servers and the technology that improves our security, efficiency, and storage capacity, which translates into a fast, secure and reliable service for both dealers and end-users.<br/><br/>

                        <strong>Technical Support</strong><br/>
                        Our in-house team of qualified tech support specialists are available to assist with any and all computer-related issues at any time. Customers can call for support with any hosted services {props.FormalDomainName} provides.<br/><br/>

                        <strong>Contact Us: <a className='mock-link' id='website-design-phone-link' href={'tel:' + props.TollFreeNumber}>{props.TollFreeNumber}</a> or <a className='mock-link' href={props.ContactUsUrl}>Click Here</a>.</strong>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DealerWebSiteDesignView;
global.DealerWebSiteDesignView = DealerWebSiteDesignView;